import { isPlatformServer, Location } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { REQUEST, RESPONSE } from '@nguniversal/express-engine/tokens';
import * as express from './express-ssr';

export interface FormHandlingComponent {
    submit();
}

export function FormInput(inputName : string = null) {
    return (target : any, propertyKey : any) => {
        Reflect.defineMetadata('form:input-name', propertyKey, target, inputName || propertyKey);
    }
}

@Injectable()
export class FormHandler {
    constructor(
        @Inject(REQUEST) @Optional()
        private request : express.ExpressRequest,
        @Inject(RESPONSE) @Optional()
        private response : express.ExpressResponse,

        @Inject(PLATFORM_ID)
        private platformId : any,

        private location : Location
    ) {
        this.isServer = isPlatformServer(this.platformId);
    }

    public isServer : boolean = false;

    public get currentPath() {
        return this.request 
            ? this.request.path 
            : this.location.path();
    }

    handle(cmp : FormHandlingComponent) {

        // Handle server-side login
        if (!this.isSubmission())
            return;
        
        this.applyData(cmp, this.getData());
        cmp.submit();
    }

    applyData(cmp : FormHandlingComponent, data : any) {
        for (let key of Object.keys(data)) {
            let propertyKey = Reflect.getMetadata('form:input-name', cmp, key);

            if (!propertyKey) {
                continue;
            }

            cmp[propertyKey] = data[key];
        }
    }

    isSubmission() {

        if (isPlatformServer(this.platformId) && !this.request) {
            throw new Error(`Error: We are on the server platform but no request object is available.`);
        }

        if (!this.request) {
            return false;
        }
        
        return this.request.method.toLowerCase() == 'post';
    }

    getData() {
        if (!this.request)
            throw new Error('Cannot get data on client side');
        return this.request.body;
    }

    redirect(url : string) {
        if (!this.response)
            throw new Error('Cannot redirect on client side');
        this.response.redirect(url);
    }
}